// @flow

import type {StatelessFunctionalComponent} from 'react';

import {
  HeadlineLarge,
  ParagraphMedium,
  Stack,
} from '@travel-frontend/ui-components';

import iconCalendarPath from 'assets/images/calendar.svg';
import iconLuggagePath from 'assets/images/luggage.svg';
import {Container} from 'components/PageLoading/components/Container';
import {Icon} from 'components/PageLoading/components/Icon';


type Props = {
  title?: string,
  message?: string,
  showCalendar?: boolean,
};

export const PageLoading: StatelessFunctionalComponent<Props> = ({
  title,
  message,
  showCalendar,
}) => {
  return (
    <Container>
      <Stack spacing="large">
        <img src={showCalendar ? iconCalendarPath : iconLuggagePath} alt="#" />
        {title && <HeadlineLarge>{title}</HeadlineLarge>}
        <Icon />
        {message && (
          <ParagraphMedium color="contentSecondary">{message}</ParagraphMedium>
        )}
      </Stack>
    </Container>
  );
};
